// Mock data for Giacomo Bassi website

// Social Media Links and Followers
export const socialMedia = {
  instagram: {
    url: "https://www.instagram.com/jekbassi/",
    handle: "@jekbassi",
    followers: 102000
  },
  tiktok: {
    url: "https://www.tiktok.com/@jekbassi?_r=1&_t=ZN-93msaMQibzy",
    handle: "@jekbassi",
    followers: 122878
  },
  facebook: {
    url: "https://www.facebook.com/people/Giacomo-Bassi/100009568240250/?locale=it_IT",
    handle: "Giacomo Bassi",
    followers: 5829
  },
  youtube: {
    url: "https://www.youtube.com/channel/UCHTeay26mZ9i7UlgL_45BPQ",
    handle: "Giacomo Bassi",
    subscribers: 500
  },
  totalFollowers: 231207
};

export const biography = {
  title: "Giacomo Bassi",
  subtitle: "FROM ZERO TO HERO",
  intro: "Italian international showjumping rider competing at the highest levels",
  bio: `Giacomo Bassi, conosciuto nel mondo equestre come Jekbassi, non nacque cavaliere: lo diventò.
Cresciuto ai margini di una piccola città di motori, scelse di fare tutt'altro.
Come tutti imparò presto che la strada è lunga e costosa, i cavalli non si dominano, si ascoltano ed i risultati non si pretendono. Mentre gli altri bambini sognavano stadi e riflettori, lui aspettava che i nonni lo venissero a prendere guardando "quelli" più bravi, osservandone i movimenti, cercando di capire perchè il pony facesse con loro cose che con lui non faceva. 
Non si sentiva mai abbastanza bravo. 
È lì che nacque il suo vero talento: la connessione.

Il salto ostacoli arrivò quasi per sfida. All'inizio erano gare basse, percorsi imperfetti, cadute che bruciavano più nell'orgoglio che nel corpo. 
Ma Giacomo aveva una qualità rara: la fame feroce. 
Ogni errore diventava studio, ogni rifiuto del cavallo una domanda da porsi, mai una colpa da attribuire.

Il soprannome Jekbassi venne dal tecnico che riusci a vedere questa sensibilità e la sua voglia bruciante di essere migliore.
Una lenta crescita studiata, sofferta, lontano da casa e poi le prime competizioni importanti. 
In campo gara sembrava trasformarsi: fuori riservato, quasi silenzioso; dentro il rettangolo, preciso, audace, con uno sguardo che non tremava nemmeno davanti agli ostacoli più tecnici. Come se cavallo e cavaliere diventassero un solo respiro.

La sua carriera non fu una linea retta. Ci furono infortuni, cavalli persi, stagioni difficili e momenti in cui smettere sembrava la scelta più semplice. 
Ma Giacomo non cercava la vittoria fine a sé stessa: cercava il salto perfetto, quello in cui tutto è armonia, fiducia e coraggio condiviso.

Quando arrivarono i grandi concorsi, non cambiò. Stessa cura, stesso rispetto, stesso rituale prima di entrare in campo. Perché per Jekbassi il salto ostacoli non è superare una barriera: è dimostrare che due esseri diversi possono capirsi senza parole, lanciandosi insieme nel vuoto con la certezza di atterrare più forti.

Il suo approccio allo sport è sempre stato concreto. Ogni gara, che fosse un successo o una difficoltà, è diventata un'occasione di crescita. Le cadute, gli errori di percorso, i momenti complicati fanno parte del cammino tanto quanto i risultati positivi. Ed è proprio lì che si è formato il cavaliere: nella capacità di non cercare scorciatoie e di migliorarsi passo dopo passo.

Per Giacomo il cavallo non è mai uno strumento, ma un partner. La fiducia, costruita nel lavoro quotidiano, è la base di ogni risultato. Questo legame è ciò che rende il suo modo di montare riconoscibile: essenziale, rispettoso, orientato all'equilibrio più che all'esibizione.
Sapendo che ogni percorso è il risultato di tutto il lavoro fatto prima, lontano dal pubblico.

La sua carriera dimostra che nel salto ostacoli non esistono miracoli, ma costanza. Giorni buoni e giorni difficili convivono, e la differenza la fa chi continua ad andare in scuderia anche quando i risultati non arrivano subito.

La storia di Giacomo Bassi è motivazionale perché è reale: parla di impegno, di fiducia costruita nel tempo e della scelta quotidiana di non mollare. Un percorso che insegna che il vero successo non è solo superare un ostacolo, ma crescere insieme al proprio cavallo, un salto alla volta.

E ancora oggi, ogni volta che un cavallo stacca da terra sotto di lui, Giacomo Bassi non cerca applausi.
Cerca quel momento sospeso, perfetto, in cui il mondo tace e resta solo il volo.`,
  achievements: [
    "Winner - Sei Barriere Loro Piana (2.00m) with Milles, CSIO5* Piazza di Siena Roma (2026)",
    "Winner - €60,000 Grand Prix CSI3* 1.55m Busto Arsizio, Etrea Equestrian Tour (2026)",
    "Winner - Grand Prix CSI3* 1.50m San Giovanni in Marignano, Spring Tour (2026)",
    "Winner - Longines Ranking 1.50m, CSI3* Adriatic Tour Cervia (2026)",
    "Italy Team - Mediterranean Games Taranto 2026: 9th Individual, 4th Team",
    "2nd Place Team - Longines EEF Series Nations Cup, CSIO3* Bedizzole (2026)",
    "3rd Place - Grand Prix CSI3* 1.55m Valencia (2026)",
    "Winner - €105,500 Lotto Cup Grand Prix, CSIO4* Sopot (2025)",
    "Italy Team - Longines EEF Series Final, Avenches (2025)",
    "Second Place - Speed Class, CSIO5* Piazza di Siena (2025)"
  ],
  instagram: "jekbassi",
  feiId: "10035513",
  age: 35,
  worldRanking: {
    position: "#203",
    points: "1083 pts",
    updated: "September 2026"
  },
  feiStats: {
    starts: 1417,
    wins: 38
  },
  combinationRankings: [
    { horse: "Cape Cod", rank: 415, points: 371 },
    { horse: "Cash Du Pratel", rank: 483, points: 340 }
  ]
};

export const horses = [
  {
    id: 1,
    name: "CAPE COD",
    feiId: "107HP83",
    subtitle: "Top Grand Prix Horse",
    breed: "MASAF",
    sire: "Tornesch 1042",
    dam: "Peau D'ane",
    damSire: "Kashmir Van Schuttershof",
    born: "2013",
    color: "Bay",
    gender: "Stallion",
    stats: { starts: 179, wins: 8 },
    description: "Stallone baio nato il 6 Maggio 2013. Cavallo di punta della scuderia con 179 partenze FEI e 8 vittorie. Nel 2026 ha vinto la Longines Ranking 1.50m del CSI3* di Cervia (netto in 62.57s), è salito sul podio nei Gran Premi CSI2* di Bedizzole e San Giovanni in Marignano e ha rappresentato l'Italia ai Giochi del Mediterraneo di Taranto 2026 (9° individuale, 4° a squadre) con quattro percorsi netti. Nel 2025 ha vinto il €105,500 Lotto Cup Grand Prix al CSIO4* di Sopot. Attualmente 415° nel ranking FEI dei binomi.",
    achievements: [
      "Winner - Longines Ranking 1.50m CSI3* Cervia (2026)",
      "9th Individual & 4th Team - Mediterranean Games Taranto (2026)",
      "3rd - Grand Prix CSI2* 1.45m San Giovanni in Marignano (2026)",
      "3rd - Grand Prix CSI2* Bedizzole (2026)",
      "9th - Grand Prix CSI3* 1.55m Abbasanta (2026)",
      "Winner - €105,500 CSIO4* Sopot Grand Prix 1.60m (2025)",
      "179 FEI Starts - 8 Wins"
    ],
    image: "https://customer-assets.emergentagent.com/job_b6c20734-bb90-4750-94f8-baaefceffec0/artifacts/u5xeznbs_0BB67347-AEDE-46EB-A00E-65AB38FEB213.jpeg"
  },
  {
    id: 2,
    name: "CASH DU PRATEL",
    feiId: "105YN30",
    subtitle: "Grand Prix Winner 2026",
    breed: "SF (Selle Français)",
    sire: "L'Arc de Triomphe",
    dam: "Quina de Coquerie",
    damSire: "Feofar de Rhodes",
    born: "2012",
    color: "Bay",
    gender: "Gelding",
    stats: { starts: 161, wins: 5 },
    description: "Castrone baio nato il 20 Maggio 2012. Selle Français con 161 partenze FEI e 5 vittorie. Protagonista della stagione 2026: ha vinto il Gran Premio CSI3* di San Giovanni in Marignano (0/0, 38.75s) e il Gran Premio CSI3* 1.55m da €60,000 di Busto Arsizio (0/0, 39.74s su 60 partenti), oltre al terzo posto nel GP CSI3* di Valencia e al secondo posto a squadre nella Longines EEF Series Nations Cup di Bedizzole. Attivo anche nel circuito Longines FEI Jumping World Cup. 483° nel ranking FEI dei binomi.",
    achievements: [
      "Winner - €60,000 Grand Prix CSI3* 1.55m Busto Arsizio (2026)",
      "Winner - Grand Prix CSI3* 1.50m San Giovanni in Marignano (2026)",
      "3rd - Grand Prix CSI3* 1.55m Valencia (2026)",
      "2nd Team - Longines EEF Series Nations Cup CSIO3* Bedizzole (2026)",
      "9th - CSI5* 1.55m Lido di Camaiore (2026)",
      "Longines FEI Jumping World Cup Verona CSI5*-W (2025)",
      "161 FEI Starts - 5 Wins"
    ],
    image: "https://customer-assets.emergentagent.com/job_b6c20734-bb90-4750-94f8-baaefceffec0/artifacts/4lyv255a_C3490C5B-B390-4070-BA5B-AD7B28D8853F_1_201_a.jpeg"
  },
  {
    id: 3,
    name: "COMME LE ROI DEL MAGI",
    feiId: "108RH31",
    subtitle: "Rising Star",
    breed: "AES",
    sire: "Comme Il Faut",
    dam: "Cento Lano",
    breeder: "Dirk Lambrecht",
    owner: "Anna Veronese",
    born: "2017",
    color: "Grey",
    gender: "Mare",
    description: "Cavalla grigia di 9 anni by Comme Il Faut. Nel Settembre 2026 ha chiuso al 6° posto con doppio netto (43.79s) il Gran Premio H145 del CSI2* di Palermo. Ha gareggiato a Fieracavalli Verona CSI5*-W classificandosi 9° nella classe 150cm ed è attiva nei circuiti CSI2*/CSI3* italiani.",
    achievements: [
      "6th - Grand Prix CSI2* H145 Palermo (0/0, 2026)",
      "9th - CSI5*-W Verona 150cm (2025)",
      "Longines FEI World Cup Grand Prix Verona",
      "CSI2* San Giovanni in Marignano H140 (2026)"
    ],
    image: "https://customer-assets.emergentagent.com/job_b6c20734-bb90-4750-94f8-baaefceffec0/artifacts/zzxptmph_FILE_9HV_4528.jpg"
  },
  {
    id: 4,
    name: "AGA BLUE DMH Z",
    feiId: "107PX43",
    subtitle: "The Speed Master",
    breed: "ZANG (Zangersheide)",
    sire: "Aganix du Seigneur Z",
    damSire: "Mr. Blue",
    owner: "Eric Berkhof Paarden BV",
    born: "2017",
    color: "Chestnut",
    gender: "Stallion",
    stats: { starts: 49, wins: 2 },
    description: "Stallone sauro Zangersheide di 9 anni con 49 partenze FEI e 2 vittorie. Ha partecipato al FEI WBFSH Young Horse Championships a Lanaken. Conosciuto per la sua incredibile velocità.",
    achievements: [
      "49 FEI Starts - 2 Wins",
      "FEI WBFSH Young Horse Championships Lanaken",
      "Andalucía Sunshine Tour",
      "Young Horse Classes 1.05m-1.40m"
    ],
    image: "https://customer-assets.emergentagent.com/job_b6c20734-bb90-4750-94f8-baaefceffec0/artifacts/njl8cq91_53B1EDDE-3CF7-4B4A-9CD6-5CDA2242C81C.jpeg"
  },
  {
    id: 5,
    name: "MILLES",
    feiId: "107WS82",
    subtitle: "Limitless Power",
    breed: "Sella Italiano",
    sire: "Tangelo van de Zuuthoeve",
    dam: "Inkies Bianaluna",
    owner: "Sergio Melotto",
    born: "2017",
    color: "Grey",
    gender: "Mare",
    description: "Cavalla grigia italiana nata nel 2017. Il 30 Maggio 2026 ha scritto la storia vincendo la Sei Barriere Loro Piana allo CSIO5* di Piazza di Siena, superando l'ultimo ostacolo a 2 metri di altezza al terzo barrage. Nel 2026 ha debuttato anche nelle categorie ranking 1.45m dei CSI3* di Cervia. Ha partecipato al FEI WBFSH World Breeding Championship for Young Horses 2023 a Zangersheide.",
    achievements: [
      "Winner - Sei Barriere Loro Piana 2.00m, CSIO5* Piazza di Siena (2026)",
      "CSI3* Riviera Resort Cervia H145 Ranking (2026)",
      "CSI2* Gorla Minore H140 (2025)",
      "FEI WBFSH Young Horse Championships 2023"
    ],
    image: "https://customer-assets.emergentagent.com/job_b6c20734-bb90-4750-94f8-baaefceffec0/artifacts/ykvawq1u_0DEF63F4-3906-4684-A00E-727BA58246DC.jpeg"
  },
  {
    id: 6,
    name: "GET IN TOUCH",
    feiId: "108QK86",
    subtitle: "The Freak",
    breed: "MASA Bay",
    sire: "Unknown",
    born: "2018",
    color: "Bay",
    gender: "Stallion",
    description: "Stallone baio di 8 anni registrato in Italia. Nel 2026 è passato con successo alle categorie Gran Premio: 3° posto con doppio netto nel Gran Premio C145 del concorso A5* Le Siepi di Cervia (Giugno 2026) e 4° nel GP C145 di Luglio 2026, oltre a un 3° posto nella C135 a tempo.",
    achievements: [
      "3rd - Gran Premio C145 A5* Le Siepi Cervia (0/0, June 2026)",
      "4th - Gran Premio C145 A5* Le Siepi Cervia (July 2026)",
      "3rd - C135 a tempo A5* Le Siepi (July 2026)",
      "3rd - Prix N.101 6YH (0 faults)"
    ],
    image: "https://customer-assets.emergentagent.com/job_b6c20734-bb90-4750-94f8-baaefceffec0/artifacts/2z92v0tp_2F254F62-C1A6-46E6-8BD1-762B08C70458.jpeg"
  },
  {
    id: 7,
    name: "LANIMOTREN",
    feiId: "107YO99",
    subtitle: "Grand Prix Winner 2026",
    breed: "KWPN",
    sire: "Zambesi TN",
    born: "2016",
    color: "Bay",
    gender: "Stallion",
    description: "Stallone baio KWPN nato nel 2016 by Zambesi TN. Stagione 2026 in grande crescita: ha vinto il Gran Premio C145 a due manches del concorso A5* Le Siepi di Cervia (0/0, 38.67s, Giugno 2026) e la C140 a fasi consecutive di Luglio 2026, e nel Settembre 2026 si è classificato 4° nella H145 Ranking del CSI2* di Palermo. Ha gareggiato ai FEI WBFSH Young Horse Championships di Lanaken.",
    achievements: [
      "Winner - Gran Premio C145 A5* Le Siepi Cervia (0/0, June 2026)",
      "Winner - C140 fasi consecutive A5* Le Siepi (July 2026)",
      "4th - H145 Ranking CSI2* Palermo (Sept 2026)",
      "3rd - C140 a tempo A5* Le Siepi (July 2026)",
      "6th - Gran Premio C145 A5* Le Siepi (July 2026)",
      "FEI WBFSH Young Horse Championships Lanaken"
    ],
    image: "https://customer-assets.emergentagent.com/job_11a5c023-0086-4456-b2f2-508c2ca946e7/artifacts/vv9yfy46_2018_0102_00401800%282%29.jpg",
    gallery: [
      "https://customer-assets.emergentagent.com/job_11a5c023-0086-4456-b2f2-508c2ca946e7/artifacts/vv9yfy46_2018_0102_00401800%282%29.jpg",
      "https://customer-assets.emergentagent.com/job_11a5c023-0086-4456-b2f2-508c2ca946e7/artifacts/46fktsj9_DSCF4356.jpg",
      "https://customer-assets.emergentagent.com/job_11a5c023-0086-4456-b2f2-508c2ca946e7/artifacts/ms0qqk24_DSCF4357.jpg"
    ]
  },
  {
    id: 8,
    name: "DOOMSDAY Z",
    feiId: "108OB94",
    subtitle: "Competition Horse",
    breed: "Zangersheide",
    sire: "Dominator 2000 Z",
    born: "2016",
    color: "Bay",
    gender: "Gelding",
    description: "Castrone baio Zangersheide di 10 anni nato il 1 Giugno 2016. Figlio di Dominator 2000 Z. Ha gareggiato in eventi FEI fino a H135 in Italia (Riviera Resort CSI2* 2025).",
    achievements: [
      "FEI ID: 108OB94",
      "Active FEI Competitor",
      "H135 Classes",
      "National & International Events"
    ],
    image: "https://customer-assets-m6fa6gv7.emergentagent.net/job_29f1692c-a425-446e-8bed-aa7e71f3f8b0/artifacts/mh14f49j_IMG_1302.webp"
  },
  {
    id: 9,
    name: "CASALL DU FOREZAN Z",
    feiId: "109IG42",
    subtitle: "Rising Talent",
    breed: "Zangersheide",
    sire: "Casall",
    damSire: "Diamant de Semilly",
    breeder: "E.A.R.L. Ecuries de Beauvoir",
    born: "2019",
    color: "Chestnut",
    gender: "Gelding",
    description: "Castrone sauro Zangersheide di 7 anni dalla leggendaria linea di Casall (noto nei concorsi nazionali come G&G Casall du Forezan). Nell'estate 2026 si è messo in evidenza al concorso A5* Le Siepi di Cervia con un 3° posto nella C140 a fasi consecutive (0/0) e numerosi netti nelle C135. Ha gareggiato all'Andalucia Sunshine Tour di Vejer de la Frontera nelle classi per giovani cavalli.",
    achievements: [
      "3rd - C140 fasi consecutive A5* Le Siepi Cervia (0/0, July 2026)",
      "6th - C135 a tempo A5* Le Siepi (July 2026)",
      "Andalucía Sunshine Tour Competitor",
      "Casall Bloodline (CSI5* GP Winner)"
    ],
    image: "https://customer-assets.emergentagent.com/job_b6c20734-bb90-4750-94f8-baaefceffec0/artifacts/li2m45om_031E8E38-0F00-4028-A320-4C2D49C8FD2D_1_201_a.jpeg"
  },
  {
    id: 10,
    name: "CORNET DE FAB",
    feiId: "107DO30",
    subtitle: "New Arrival 2026",
    breed: "MASAF",
    sire: "Cornet Obolensky",
    dam: "Hella Si'",
    damSire: "Stakkato",
    born: "2015",
    color: "Grey",
    gender: "Stallion",
    stats: { starts: 68, wins: 0 },
    description: "Stallone grigio nato il 15 Giugno 2015, figlio del leggendario Cornet Obolensky. Entrato in scuderia nel 2026, ha debuttato con Giacomo al Riviera Resort Summer Tour di Cervia (CSI2*/CSI3*) e nel Settembre 2026 ha ottenuto il 4° posto nella H130 a due fasi e il 6° posto nella H140 a tempo del CSI2* di Palermo, entrambi con percorso netto.",
    achievements: [
      "4th - H130 Two Phases CSI2* Palermo (0/0, Sept 2026)",
      "6th - H140 Against the Clock CSI2* Palermo (0, Sept 2026)",
      "CSI3* Riviera Resort Cervia H145 Ranking (2026)",
      "68 FEI Starts"
    ],
    image: "https://customer-assets-m6fa6gv7.emergentagent.net/job_29f1692c-a425-446e-8bed-aa7e71f3f8b0/artifacts/fgj795z7_IMG_3849.jpg"
  }
];

export const news = [
  {
    id: 12,
    title: "Double Clear for Comme Le Roi in Palermo Grand Prix",
    date: "September 27, 2026",
    category: "Competition Results",
    excerpt: "Giacomo closes the CSI2* La Favorita in Palermo with a 6th place in the H145 Grand Prix riding Comme Le Roi Del Magi (0/0, 43.79s), while Lanimotren takes 4th in the H145 Ranking class.",
    image: "https://customer-assets.emergentagent.com/job_b6c20734-bb90-4750-94f8-baaefceffec0/artifacts/zzxptmph_FILE_9HV_4528.jpg",
    content: "A strong team weekend in Sicily: Comme Le Roi Del Magi jumped a double clear in the Grand Prix H145 to finish 6th, Lanimotren was 4th in the H145 Longines Ranking class, and the new grey stallion Cornet De Fab collected a 4th place in the H130 two-phase and a 6th in the H140 against the clock, both clear. Cape Cod also jumped clear in the H135 speed class."
  },
  {
    id: 11,
    title: "Mediterranean Games Taranto 2026: 9th Individual, 4th with Team Italy",
    date: "September 2, 2026",
    category: "Team Selection",
    excerpt: "Selected for the Italian team at the Mediterranean Games in Taranto, Giacomo and Cape Cod jumped four clear rounds and finished 9th in the individual final, the best Italian result, and 4th in the team competition.",
    image: "https://www.fise.it/images/AAANEWS2016/2026/G.-bassi---cape-cpd-MG.jpg",
    content: "From 28 August to 1 September, 15 nations met at the Horse Club of Terra Ionica for the show jumping competitions of the Mediterranean Games. Giacomo Bassi, alongside Matteo Zamana, Emilio Bicocchi, Lorenzo Correddu and Elisa Chimirri under Chef d'Equipe Marco Bergomi, secured 4th place in the team final. In the individual competition designed by Uliano Vezzani, Giacomo and Cape Cod finished 9th with 7 total penalties (0/7/0/0). \"The horse was fantastic - we finished four rounds without touching a rail. An unexpected incident in the second round of the team competition, probably due to the lights, cost us seven penalties and the chance to fight for the medals in the jump-off. Competing against 15 nations at this level was a privilege,\" said Giacomo."
  },
  {
    id: 10,
    title: "Cape Cod Wins the Longines Ranking 1.50m at CSI3* Cervia",
    date: "August 7, 2026",
    category: "Competition Results",
    excerpt: "Italian success in the first Longines Ranking class of the Adriatic Tour: Giacomo and Cape Cod were the fastest of 53 combinations on the grass arena at Le Siepi, clear in 62.57 seconds.",
    image: "https://www.horseshowjumping.tv/wp-content/uploads/2026/08/Giacomo-BassiCape-Cod_SS7_3518-1536x1024.jpg",
    content: "On the grass field of Le Siepi equestrian centre in Cervia, 53 riders took on the 1.50m against the clock, a Longines Ranking class with €28,500 in prize money. Only 11 jumped clear, and Giacomo Bassi with Cape Cod stopped the clock in 62.57 seconds, almost two seconds faster than runner-up Roberto Turchetto on Bubalou (64.51). Argentina's Matias Larocca completed the podium with Con Corrado 4. Another important result for the pair after the 3rd place in the CSI2* Grand Prix of Bedizzole in June and the 3rd place in the CSI2* Grand Prix of San Giovanni in Marignano the previous weekend."
  },
  {
    id: 9,
    title: "Giacomo Bassi Wins the Sei Barriere Loro Piana at Piazza di Siena",
    date: "May 30, 2026",
    category: "Competition Results",
    excerpt: "A historic Italian victory at the CSIO5* of Rome: Giacomo and the grey mare Milles clear the final fence at 2.00 metres to win the spectacular Sei Barriere Loro Piana at the 100th edition of Piazza di Siena.",
    image: "https://www.horseshowjumping.tv/wp-content/uploads/2026/06/BASSI-Giacomo-ITA-MILLES_Roma2026_30-05-26_SS359014-1536x1024.jpg",
    content: "On a beautiful sunny Saturday in front of a packed crowd, the Sei Barriere Loro Piana was an all-Italian affair. Giacomo Bassi and the Italian-bred grey Milles were the only pair to clear the last fence set at 2.00 metres in the third jump-off, beating Lorenzo De Luca on Baskin Smooth Diamond who had a fault. After sharing first place in 2025 with another horse, this victory confirms Giacomo as a true specialist of the puissance. \"Piazza di Siena has always been one of my dreams. Doing well here, and winning the Coppa Roma, is still one of my goals. The difference is that today I know these targets are within reach,\" Giacomo said."
  },
  {
    id: 8,
    title: "Second Place with Team Italy in the Longines EEF Series Nations Cup",
    date: "May 15, 2026",
    category: "Team Selection",
    excerpt: "Giacomo and Cash du Pratel help the Italian team to 2nd place in the Longines EEF Series Nations Cup at CSIO3* Borgo La Caccia, Bedizzole.",
    image: "https://customer-assets.emergentagent.com/job_bassi-riding/artifacts/s1jud9ek_IMG_9893.jpeg",
    content: "Called up once again by the Italian federation for the Nations Cup, Giacomo Bassi rode Cash du Pratel over the 1.50m course of the Longines EEF Series qualifier at Borgo La Caccia. Team Italy finished second, an important step in the road to the EEF Series Final. \"I would love to keep having opportunities to represent Italy and give my contribution in the Nations Cups. So far things have gone well and I feel ready to keep supporting the team,\" Giacomo commented."
  },
  {
    id: 7,
    title: "Giacomo Bassi Wins the €60,000 Grand Prix CSI3* of Busto Arsizio",
    date: "April 5, 2026",
    category: "Competition Results",
    excerpt: "Second Grand Prix victory of the season for Giacomo and Cash du Pratel: fastest of 11 in the jump-off (0/0, 39.74s) over a 1.55m course with 60 starters at the Etrea Equestrian Tour.",
    image: "https://www.fise.it/images/AAANEWS2016/2026/SALTO_OSTACOLI/bassi_giacomo_ITA_cash_du_pratel_Fusetti.jpg",
    content: "The CSI3* of Busto Arsizio closed with its most anticipated class, the Longines Ranking Grand Prix with €60,000 in prize money. Over the 1.55m track only 11 of the 60 starters reached the jump-off, where Giacomo Bassi and the generous Cash du Pratel (2012, Selle Français, L'Arc de Triomphe x Feofar de Rhodes) produced a flawless double clear in 39.74 seconds, a time nobody could approach. Switzerland's Bryan Smits (Verdi van 't Laerhof Z, 39.95) and Alain Jufer (Chaccoo de Lescant MM, 40.93) completed the podium. In March the same pair had already taken 3rd place in the CSI3* Grand Prix of Valencia."
  },
  {
    id: 6,
    title: "Victory in the Grand Prix CSI3* San Giovanni in Marignano",
    date: "February 15, 2026",
    category: "Competition Results",
    excerpt: "Giacomo Bassi and Cash du Pratel win the 1.50m Grand Prix that closed the Spring Tour 2026, best of 43 riders with a double clear in 38.75 seconds.",
    image: "https://www.fise.it/images/AAANEWS2016/2025/SALTO-OSTACOLI/BASSI-CASH-DU-PRATEL.jpg",
    content: "Another Italian victory in the Grand Prix of the CSI3* of San Giovanni in Marignano. Giacomo Bassi (0/0; 38.75) in the saddle of Cash du Pratel was the best of the 43 riders on the 1.50m course, ahead of Alberto Zorzi with Neptune de Muze (0/0; 39.09). Fifteen combinations qualified for the jump-off, with Arnaldo Bologni 4th, Elisa Chimirri 5th and Samuele Maestri 8th also producing double clears. The perfect start to the 2026 season."
  },
  {
    id: 1,
    title: "Blazing Victory at CSIO Sopot",
    date: "June 17, 2025",
    category: "Competition Results",
    excerpt: "Giacomo Bassi and Cape Cod delivered an outstanding performance to win the €105,500 Lotto Cup Grand Prix at CSIO Sopot, Poland, with a clear round in 43.08 seconds.",
    image: "https://customer-assets.emergentagent.com/job_bassi-riding/artifacts/p0zv4zkx_IMG_9390.jpeg",
    content: "In a thrilling display of precision and speed, Giacomo Bassi rode Cape Cod to victory in the prestigious Lotto Cup Grand Prix. The Italian rider dominated the jump-off with a clear round, finishing ahead of Belgium's Rik Hemeryck and Denmark's Renee Ulvsbjerg. This win marks a significant milestone in the 2025 season."
  },
  {
    id: 2,
    title: "Selected for Longines EEF Series Final",
    date: "September 3, 2025",
    category: "Team Selection",
    excerpt: "Giacomo has been selected to represent Italy at the Longines EEF Series Final in Avenches, Switzerland, as part of the national team.",
    image: "https://customer-assets.emergentagent.com/job_bassi-riding/artifacts/mq5pd20s_IMG_9446.jpeg",
    content: "Italy's showjumping elite will compete at Avenches for the Longines EEF Series Final. As defending champions from 2021, 2022, and 2024, the team carries high expectations. Giacomo joins teammates including Emanuele Camilli and Giulia Martinengo Marquet in pursuit of another championship title."
  },
  {
    id: 3,
    title: "Strong Performance at Piazza di Siena",
    date: "May 15, 2025",
    category: "Competition Results",
    excerpt: "Giacomo and Cape Cod secured a podium finish in the speed class at Rome's prestigious Piazza di Siena, recording an impressive time of 36.79 seconds.",
    image: "https://customer-assets.emergentagent.com/job_bassi-riding/artifacts/f2yw33fh_5e20b532-618b-4b75-bc32-b5e57dd0f61f.jpeg",
    content: "Competing in front of a home crowd at Italy's most prestigious equestrian event, Giacomo delivered a stellar performance with Cape Cod. The partnership continues to strengthen, showing consistency at the highest levels of international competition."
  },
  {
    id: 4,
    title: "World Cup Season Begins",
    date: "February 10, 2025",
    category: "Competition Updates",
    excerpt: "Giacomo Bassi starts the Longines FEI Jumping World Cup 2025-2026 season with Cash du Pratel at WEL Verona.",
    image: "https://customer-assets.emergentagent.com/job_bassi-riding/artifacts/kw2ddzkw_DCBDDB18-E751-4CD9-B859-301A9EE144A5.jpeg",
    content: "The new World Cup season is underway with exciting performances. Giacomo and Cash du Pratel are showing excellent form in the qualifying rounds, demonstrating the dedication and preparation that goes into competing at this elite level."
  }
];

export const shop = [
  {
    id: 1,
    name: "Official Team Cap",
    price: 35.00,
    currency: "EUR",
    category: "Accessories",
    image: "https://images.unsplash.com/photo-1588850561407-ed78c282e89b",
    description: "Premium quality cap featuring Giacomo Bassi official branding. Perfect for riders and fans alike.",
    sizes: ["One Size"],
    inStock: true
  },
  {
    id: 2,
    name: "Performance Polo Shirt",
    price: 89.00,
    currency: "EUR",
    category: "Apparel",
    image: "https://images.unsplash.com/photo-1586790170083-2f9ceadc732d",
    description: "High-performance polo shirt in team colors. Breathable fabric perfect for competition and casual wear.",
    sizes: ["S", "M", "L", "XL", "XXL"],
    inStock: true
  },
  {
    id: 3,
    name: "Technical Training Jacket",
    price: 149.00,
    currency: "EUR",
    category: "Apparel",
    image: "https://images.unsplash.com/photo-1551028719-00167b16eac5",
    description: "Weather-resistant training jacket with team branding. Essential for all-weather training sessions.",
    sizes: ["S", "M", "L", "XL"],
    inStock: true
  },
  {
    id: 4,
    name: "Signature Riding Gloves",
    price: 55.00,
    currency: "EUR",
    category: "Riding Gear",
    image: "https://images.unsplash.com/photo-1605408499391-6368c628ef42",
    description: "Premium leather riding gloves with excellent grip and feel. Official Giacomo Bassi collection.",
    sizes: ["6", "7", "8", "9"],
    inStock: false
  },
  {
    id: 5,
    name: "Team Hoodie",
    price: 79.00,
    currency: "EUR",
    category: "Apparel",
    image: "https://images.unsplash.com/photo-1556821840-3a63f95609a7",
    description: "Comfortable cotton-blend hoodie with embroidered team logo. Perfect for casual wear.",
    sizes: ["S", "M", "L", "XL", "XXL"],
    inStock: true
  },
  {
    id: 6,
    name: "Official Water Bottle",
    price: 25.00,
    currency: "EUR",
    category: "Accessories",
    image: "https://images.unsplash.com/photo-1602143407151-7111542de6e8",
    description: "Stainless steel insulated water bottle with team branding. 750ml capacity.",
    sizes: ["One Size"],
    inStock: true
  }
];

export const sponsors = {
  mainSponsors: [
    {
      id: 1,
      name: "VEREDUS",
      description: "High-end protective equipment for sport horses",
      website: "https://www.veredus.com",
      logo: "https://customer-assets.emergentagent.com/job_11a5c023-0086-4456-b2f2-508c2ca946e7/artifacts/1z2fyd2z_Schermata%202026-02-09%20alle%2021.53.56.png"
    },
    {
      id: 2,
      name: "PRESTIGE",
      description: "Italian saddle excellence since 1974",
      website: "https://www.prestigeitalia.com",
      logo: "https://customer-assets.emergentagent.com/job_11a5c023-0086-4456-b2f2-508c2ca946e7/artifacts/nfoc7b2k_Schermata%202026-02-09%20alle%2021.54.40.png"
    },
    {
      id: 3,
      name: "OPHENA",
      description: "Magnetic safety stirrups",
      website: "https://ophena.com",
      logo: "https://customer-assets.emergentagent.com/job_11a5c023-0086-4456-b2f2-508c2ca946e7/artifacts/gv4153is_Schermata%202026-02-09%20alle%2021.55.57.png"
    },
    {
      id: 4,
      name: "FREEJUMP",
      description: "Revolutionary stirrup systems",
      website: "https://www.freejumpsystem.com",
      logo: "https://customer-assets.emergentagent.com/job_11a5c023-0086-4456-b2f2-508c2ca946e7/artifacts/l3md9hk8_Schermata%202026-02-09%20alle%2021.56.25.png"
    },
    {
      id: 5,
      name: "EQUESTRO",
      description: "Italian equestrian equipment and apparel",
      website: "https://www.equestro.com",
      logo: "https://customer-assets.emergentagent.com/job_11a5c023-0086-4456-b2f2-508c2ca946e7/artifacts/i3m4vk61_Schermata%202026-02-09%20alle%2021.55.19.png"
    },
    {
      id: 6,
      name: "GOLDSPAN",
      description: "Premium horse bedding",
      website: "https://www.brandenburg-gruppe.de",
      logo: "https://customer-assets.emergentagent.com/job_11a5c023-0086-4456-b2f2-508c2ca946e7/artifacts/4dd2v37q_Schermata%202026-02-09%20alle%2021.57.06.png"
    },
    {
      id: 7,
      name: "CORTAL",
      description: "Extruded horse feed - Premium nutrition",
      website: "https://cortalhorse.it",
      logo: "https://customer-assets.emergentagent.com/job_11a5c023-0086-4456-b2f2-508c2ca946e7/artifacts/4soe5ikx_Schermata%202026-02-09%20alle%2021.57.32.png"
    },
    {
      id: 8,
      name: "FM ITALIA",
      description: "Veterinary products and supplements",
      website: "https://fmitalia.it/en",
      logo: "https://customer-assets.emergentagent.com/job_11a5c023-0086-4456-b2f2-508c2ca946e7/artifacts/k7w5w5g8_Schermata%202026-02-09%20alle%2021.58.38.png"
    },
    {
      id: 9,
      name: "VICTOR HANDMADE",
      description: "Handcrafted Italian riding boots since 1956",
      website: "https://victor-handmade.com/en",
      logo: "https://customer-assets.emergentagent.com/job_11a5c023-0086-4456-b2f2-508c2ca946e7/artifacts/d6nq23hy_Schermata%202026-02-09%20alle%2022.00.28.png"
    },
    {
      id: 10,
      name: "LUCKYFOX",
      description: "Hoof care - No foot, no horse",
      website: "https://www.luckyfox.it/en",
      logo: "https://customer-assets.emergentagent.com/job_11a5c023-0086-4456-b2f2-508c2ca946e7/artifacts/h4chh6cf_Schermata%202026-02-09%20alle%2021.59.51.png"
    },
    {
      id: 11,
      name: "MASC",
      description: "Italian excellence in horse care products",
      website: "https://mascheroniselleria.com/en/collections/masc",
      logo: "https://customer-assets.emergentagent.com/job_11a5c023-0086-4456-b2f2-508c2ca946e7/artifacts/wlhkoisv_Schermata%202026-02-09%20alle%2021.58.05.png"
    }
  ],
  newPartners2026: [
    {
      id: 12,
      name: "COXY",
      description: "Wellness products for horses and riders",
      website: "https://coxy.it/en",
      logo: "https://customer-assets.emergentagent.com/job_11a5c023-0086-4456-b2f2-508c2ca946e7/artifacts/gytk53uc_Schermata%202026-02-09%20alle%2022.02.41.png"
    },
    {
      id: 13,
      name: "NAUTILUS BLADE",
      description: "Advanced riding technology",
      website: null,
      logo: "https://customer-assets.emergentagent.com/job_11a5c023-0086-4456-b2f2-508c2ca946e7/artifacts/7fk0mymo_Schermata%202026-02-09%20alle%2022.01.29.png"
    },
    {
      id: 14,
      name: "GARMIN",
      description: "GPS and wearable technology",
      website: "https://www.garmin.com",
      logo: "https://customer-assets.emergentagent.com/job_11a5c023-0086-4456-b2f2-508c2ca946e7/artifacts/jj3ny8vr_Schermata%202026-02-09%20alle%2022.03.22.png"
    }
  ]
};

export const gallery = [
  {
    id: 16,
    title: "Milles - Sei Barriere Loro Piana Winner, Piazza di Siena 2026",
    date: "May 2026",
    image: "https://www.horseshowjumping.tv/wp-content/uploads/2026/06/BASSI-Giacomo-ITA-MILLES_Roma2026_30-05-26_SS359014-1536x1024.jpg",
    category: "Competition"
  },
  {
    id: 17,
    title: "Cape Cod - CSIO5* Roma 2026",
    date: "May 2026",
    image: "https://www.horseshowjumping.tv/wp-content/uploads/2026/06/BASSI-Giacomo-ITA-CAPE-COD_CSIO-Roma-2026_20260529_SS358075.jpg",
    category: "Competition"
  },
  {
    id: 18,
    title: "Cape Cod - Longines Ranking Winner, Cervia 2026",
    date: "August 2026",
    image: "https://www.horseshowjumping.tv/wp-content/uploads/2026/08/Giacomo-BassiCape-Cod_SS7_3518-1536x1024.jpg",
    category: "Competition"
  },
  {
    id: 19,
    title: "Cash du Pratel - Grand Prix Winner, Busto Arsizio 2026",
    date: "April 2026",
    image: "https://www.fise.it/images/AAANEWS2016/2026/SALTO_OSTACOLI/bassi_giacomo_ITA_cash_du_pratel_Fusetti.jpg",
    category: "Competition"
  },
  {
    id: 20,
    title: "Cape Cod - Mediterranean Games Taranto 2026",
    date: "September 2026",
    image: "https://www.fise.it/images/AAANEWS2016/2026/G.-bassi---cape-cpd-MG.jpg",
    category: "Competition"
  },
  {
    id: 1,
    title: "Piazza di Siena - Victory Lap",
    date: "May 2025",
    image: "https://customer-assets.emergentagent.com/job_bassi-riding/artifacts/enapdojs_FILE_5KZ_5238.jpeg",
    category: "Competition"
  },
  {
    id: 2,
    title: "Piazza di Siena - CSIO Roma 2025",
    date: "May 2025",
    image: "https://customer-assets.emergentagent.com/job_bassi-riding/artifacts/3j6ha38y_FILE_9HW_1769.jpeg",
    category: "Competition"
  },
  {
    id: 3,
    title: "Piazza di Siena - Jump",
    date: "May 2025",
    image: "https://customer-assets.emergentagent.com/job_bassi-riding/artifacts/xp1pqdoy_FILE_5LA_1837.jpeg",
    category: "Competition"
  },
  {
    id: 4,
    title: "Piazza di Siena - Master d'Inzeo",
    date: "May 2025",
    image: "https://customer-assets.emergentagent.com/job_bassi-riding/artifacts/l1wl8fpe_IMG_9130.jpeg",
    category: "Competition"
  },
  {
    id: 5,
    title: "Victory Celebration",
    date: "May 2025",
    image: "https://customer-assets.emergentagent.com/job_bassi-riding/artifacts/afda3q2a_IMG_9126.jpeg",
    category: "Competition"
  },
  {
    id: 6,
    title: "CSIO Sopot Victory",
    date: "June 2025",
    image: "https://customer-assets.emergentagent.com/job_bassi-riding/artifacts/p0zv4zkx_IMG_9390.jpeg",
    category: "Competition"
  },
  {
    id: 7,
    title: "Indoor Arena",
    date: "2025",
    image: "https://customer-assets.emergentagent.com/job_bassi-riding/artifacts/b1hgom9x_IMG_0574.jpeg",
    category: "Training"
  },
  {
    id: 8,
    title: "Coppa degli Assi",
    date: "2025",
    image: "https://customer-assets.emergentagent.com/job_bassi-riding/artifacts/l8m5o3bm_3ac41002-051a-4044-baff-d9448b0c3ce0.jpeg",
    category: "Competition"
  },
  {
    id: 9,
    title: "Victory Celebration",
    date: "2025",
    image: "https://customer-assets.emergentagent.com/job_bassi-riding/artifacts/tasg6rvp_a1ec38e7-b3ea-49c4-8e54-624a29209b74.jpeg",
    category: "Competition"
  },
  {
    id: 10,
    title: "Competition Jump",
    date: "June 2025",
    image: "https://customer-assets.emergentagent.com/job_bassi-riding/artifacts/mq5pd20s_IMG_9446.jpeg",
    category: "Competition"
  },
  {
    id: 11,
    title: "Training Session",
    date: "2025",
    image: "https://customer-assets.emergentagent.com/job_bassi-riding/artifacts/zorhj61d_IMG_0270.jpeg",
    category: "Training"
  },
  {
    id: 12,
    title: "Longines EEF Series",
    date: "2025",
    image: "https://customer-assets.emergentagent.com/job_bassi-riding/artifacts/s1jud9ek_IMG_9893.jpeg",
    category: "Competition"
  },
  {
    id: 13,
    title: "Indoor Competition",
    date: "2025",
    image: "https://customer-assets.emergentagent.com/job_bassi-riding/artifacts/kw2ddzkw_DCBDDB18-E751-4CD9-B859-301A9EE144A5.jpeg",
    category: "Competition"
  },
  {
    id: 14,
    title: "Training Focus",
    date: "2025",
    image: "https://customer-assets.emergentagent.com/job_bassi-riding/artifacts/ajup4j70_F29659CF-4850-4563-BF71-C5A602DA555D.jpeg",
    category: "Training"
  },
  {
    id: 15,
    title: "With My Horse",
    date: "May 2025",
    image: "https://customer-assets.emergentagent.com/job_bassi-riding/artifacts/f2yw33fh_5e20b532-618b-4b75-bc32-b5e57dd0f61f.jpeg",
    category: "Training"
  }
];

// Full 2026 show calendar (provided by Giacomo)
const S = (id, startDate, endDate, name, location, type) => ({ id, startDate, endDate, name, location, type });
export const season2026 = [
  S(1, "2026-01-23", "2026-01-25", "Naz. A5* Arezzo", "Arezzo, Italy", "A5*"),
  S(2, "2026-01-30", "2026-02-01", "Naz. A5* Manerbio", "Manerbio, Italy", "A5*"),
  S(3, "2026-02-06", "2026-02-08", "CSI2* Cattolica", "Cattolica, Italy", "CSI2*"),
  S(4, "2026-02-13", "2026-02-15", "CSI3* Cattolica", "Cattolica, Italy", "CSI3*"),
  S(5, "2026-02-20", "2026-02-22", "CSI3* Valencia", "Valencia, Spain", "CSI3*"),
  S(6, "2026-02-27", "2026-03-01", "CSI3* Valencia", "Valencia, Spain", "CSI3*"),
  S(7, "2026-03-06", "2026-03-08", "CSI2* La Caccia", "Bedizzole, Italy", "CSI2*"),
  S(8, "2026-03-13", "2026-03-15", "CSI4* La Caccia", "Bedizzole, Italy", "CSI4*"),
  S(9, "2026-03-20", "2026-03-22", "CSI4* Gorla Minore", "Gorla Minore, Italy", "CSI4*"),
  S(10, "2026-03-27", "2026-03-29", "CSI4* Arezzo", "Arezzo, Italy", "CSI4*"),
  S(11, "2026-04-03", "2026-04-05", "CSI3* Busto Arsizio", "Busto Arsizio, Italy", "CSI3*"),
  S(12, "2026-04-10", "2026-04-12", "CSI3* St. Tropez", "Saint-Tropez, France", "CSI3*"),
  S(13, "2026-04-24", "2026-04-26", "CSI4* Montefalco", "Montefalco, Italy", "CSI4*"),
  S(14, "2026-05-01", "2026-05-03", "CSI4* Montefalco", "Montefalco, Italy", "CSI4*"),
  S(15, "2026-05-08", "2026-05-10", "CSI5* Versilia", "Lido di Camaiore, Italy", "CSI5*"),
  S(16, "2026-05-15", "2026-05-17", "CSIO3* Bedizzole", "Bedizzole, Italy", "CSIO3*"),
  S(17, "2026-05-22", "2026-05-24", "Naz. A5* Cervia", "Cervia, Italy", "A5*"),
  S(18, "2026-05-29", "2026-05-31", "CSIO5* Roma - Piazza di Siena", "Rome, Italy", "CSIO5*"),
  S(19, "2026-06-12", "2026-06-14", "CSI2* Bedizzole", "Bedizzole, Italy", "CSI2*"),
  S(20, "2026-06-19", "2026-06-21", "CSI3* Bedizzole", "Bedizzole, Italy", "CSI3*"),
  S(21, "2026-06-26", "2026-06-28", "Naz. A5* Cervia", "Cervia, Italy", "A5*"),
  S(22, "2026-07-03", "2026-07-05", "CSI2* Cattolica", "Cattolica, Italy", "CSI2*"),
  S(23, "2026-07-10", "2026-07-12", "CSI3* Cattolica", "Cattolica, Italy", "CSI3*"),
  S(24, "2026-07-17", "2026-07-19", "Naz. A5* Cervia", "Cervia, Italy", "A5*"),
  S(25, "2026-07-24", "2026-07-26", "Naz. A5* Cervia", "Cervia, Italy", "A5*"),
  S(26, "2026-07-31", "2026-08-02", "CSI2* Cervia", "Cervia, Italy", "CSI2*"),
  S(27, "2026-08-07", "2026-08-09", "CSI3* Cervia", "Cervia, Italy", "CSI3*"),
  S(28, "2026-08-14", "2026-08-16", "CSI2* St. Margarethen", "St. Margarethen, Austria", "CSI2*"),
  S(29, "2026-08-28", "2026-09-01", "Mediterranean Games", "Taranto, Italy", "Games"),
  S(30, "2026-09-11", "2026-09-13", "Stage", "Training", "Stage"),
  S(31, "2026-09-18", "2026-09-20", "CSI3* Abbasanta", "Abbasanta, Sardinia", "CSI3*"),
  S(32, "2026-09-25", "2026-09-27", "CSI2* Palermo", "Palermo, Italy", "CSI2*"),
  S(33, "2026-10-01", "2026-10-04", "CSI3* Palermo", "Palermo, Italy", "CSI3*"),
  S(34, "2026-10-09", "2026-10-11", "CSI3* + CSI2* St. Tropez", "Saint-Tropez, France", "CSI3*"),
  S(35, "2026-10-16", "2026-10-18", "CSI2* Cattolica", "Cattolica, Italy", "CSI2*"),
  S(36, "2026-10-23", "2026-10-25", "CSI3* Cattolica", "Cattolica, Italy", "CSI3*"),
  S(37, "2026-10-30", "2026-11-01", "CSI3* Valencia", "Valencia, Spain", "CSI3*"),
  S(38, "2026-11-06", "2026-11-08", "CSI3* Valencia", "Valencia, Spain", "CSI3*"),
  S(39, "2026-11-13", "2026-11-15", "CSI3* Valencia", "Valencia, Spain", "CSI3*"),
  S(40, "2026-11-20", "2026-11-22", "CSI4* Valencia", "Valencia, Spain", "CSI4*"),
  S(41, "2026-11-27", "2026-11-29", "CSI3* Baicoi", "Baicoi, Romania", "CSI3*"),
  S(42, "2026-12-04", "2026-12-06", "CSI4* Baicoi", "Baicoi, Romania", "CSI4*"),
  S(43, "2026-12-11", "2026-12-13", "CSI4* Baicoi", "Baicoi, Romania", "CSI4*")
];

const todayISO = new Date().toISOString().slice(0, 10);

export const events = {
  upcoming: season2026.filter((e) => e.endDate >= todayISO && e.type !== "Stage"),
  past: [
    {
      id: 1,
      name: "CSI2* La Favorita Palermo",
      location: "Palermo, Italy",
      startDate: "2026-09-25",
      endDate: "2026-09-27",
      type: "CSI2*",
      result: "6th - Grand Prix H145 (Comme Le Roi) · 4th - H145 Ranking (Lanimotren)",
      results: [
        { placing: "6th", competition: "Grand Prix H145 (0/0)", horseId: 3 },
        { placing: "4th", competition: "H145 Longines Ranking", horseId: 7 },
        { placing: "4th", competition: "H130 Two Phases (0/0)", horseId: 10 },
        { placing: "6th", competition: "H140 Against the Clock (0)", horseId: 10 }
      ],
      newsId: 12
    },
    {
      id: 2,
      name: "CSI3* Abbasanta - Tanca Regia",
      location: "Abbasanta, Sardinia",
      startDate: "2026-09-18",
      endDate: "2026-09-20",
      type: "CSI3*",
      result: "9th - Grand Prix 1.55m (Cape Cod)",
      results: [{ placing: "9th", competition: "Grand Prix 1.55m", horseId: 1 }]
    },
    {
      id: 3,
      name: "Mediterranean Games Taranto 2026",
      location: "Taranto, Italy",
      startDate: "2026-08-28",
      endDate: "2026-09-01",
      type: "Games",
      result: "9th Individual · 4th Team Italy (Cape Cod)",
      results: [
        { placing: "9th", competition: "Individual Final", horseId: 1 },
        { placing: "4th", competition: "Team Competition - Italy", horseId: 1 }
      ],
      newsId: 11
    },
    {
      id: 4,
      name: "CSI3* Adriatic Tour Cervia",
      location: "Cervia, Italy",
      startDate: "2026-08-07",
      endDate: "2026-08-09",
      type: "CSI3*",
      result: "1st - Longines Ranking 1.50m (Cape Cod)",
      results: [
        { placing: "1st", competition: "Longines Ranking 1.50m (0, 62.57s)", horseId: 1 },
        { placing: "11th", competition: "Grand Prix 1.50m", horseId: 1 }
      ],
      newsId: 10
    },
    {
      id: 5,
      name: "CSI2* Adriatic Tour Cervia",
      location: "Cervia, Italy",
      startDate: "2026-07-31",
      endDate: "2026-08-02",
      type: "CSI2*",
      result: "3rd - Grand Prix 1.45m (Cape Cod)",
      results: [{ placing: "3rd", competition: "Grand Prix 1.45m (0/0, 42.12s)", horseId: 1 }]
    },
    {
      id: 6,
      name: "A5* Le Siepi Cervia",
      location: "Cervia, Italy",
      startDate: "2026-07-17",
      endDate: "2026-07-19",
      type: "A5*",
      result: "1st - C140 fasi consecutive (Lanimotren) · 6th - Gran Premio C145 (Lanimotren)",
      results: [
        { placing: "1st", competition: "C140 fasi consecutive (0/0)", horseId: 7 },
        { placing: "6th", competition: "Gran Premio C145", horseId: 7 },
        { placing: "6th", competition: "C135 a tempo (0)", horseId: 9 }
      ]
    },
    {
      id: 7,
      name: "CSI3* Riviera Resort Cervia",
      location: "Cervia, Italy",
      startDate: "2026-07-09",
      endDate: "2026-07-12",
      type: "CSI3*",
      result: "11th - Grand Prix 1.50m (Cape Cod)",
      results: [{ placing: "11th", competition: "Grand Prix 1.50m Ranking", horseId: 1 }]
    },
    {
      id: 8,
      name: "CSI2* Riviera Resort Summer Tour",
      location: "Cervia, Italy",
      startDate: "2026-07-02",
      endDate: "2026-07-05",
      type: "CSI2*",
      result: "6th - H145 Ranking Veredus (Cape Cod)",
      results: [{ placing: "6th", competition: "H145 Longines Ranking Veredus (0)", horseId: 1 }]
    },
    {
      id: 9,
      name: "A5* Le Siepi Cervia",
      location: "Cervia, Italy",
      startDate: "2026-06-26",
      endDate: "2026-06-28",
      type: "A5*",
      result: "1st - Gran Premio C145 (Lanimotren) · 3rd - Gran Premio C145 (Get In Touch)",
      results: [
        { placing: "1st", competition: "Gran Premio C145 (0/0, 38.67s)", horseId: 7 },
        { placing: "3rd", competition: "Gran Premio C145 (0/0)", horseId: 6 }
      ]
    },
    {
      id: 10,
      name: "CSIO5* Piazza di Siena - 100th Edition",
      location: "Rome, Italy",
      startDate: "2026-05-28",
      endDate: "2026-05-31",
      type: "CSIO5*",
      result: "1st - Sei Barriere Loro Piana 2.00m (Milles)",
      results: [{ placing: "1st", competition: "Sei Barriere Loro Piana - 2.00m", horseId: 5 }],
      newsId: 9
    },
    {
      id: 11,
      name: "CSIO3* Borgo La Caccia - Longines EEF Series",
      location: "Bedizzole, Italy",
      startDate: "2026-05-14",
      endDate: "2026-05-17",
      type: "CSIO3*",
      result: "2nd Team Italy - Longines EEF Series Nations Cup (Cash du Pratel)",
      results: [{ placing: "2nd", competition: "Nations Cup 1.50m - Team Italy", horseId: 2 }],
      newsId: 8
    },
    {
      id: 12,
      name: "CSI5* Lido di Camaiore - Versilia",
      location: "Lido di Camaiore, Italy",
      startDate: "2026-05-07",
      endDate: "2026-05-10",
      type: "CSI5*",
      result: "9th - Table A 1.55m (Cash du Pratel)",
      results: [{ placing: "9th", competition: "Table A 1.55m", horseId: 2 }]
    },
    {
      id: 13,
      name: "CSI3* Busto Arsizio - Etrea Equestrian Tour",
      location: "Busto Arsizio, Italy",
      startDate: "2026-04-02",
      endDate: "2026-04-05",
      type: "CSI3*",
      result: "1st - €60,000 Grand Prix 1.55m (Cash du Pratel)",
      results: [{ placing: "1st", competition: "€60,000 Grand Prix 1.55m (0/0, 39.74s)", horseId: 2 }],
      newsId: 7
    },
    {
      id: 14,
      name: "CSI3* Valencia - Mediterranean Equestrian Tour",
      location: "Valencia, Spain",
      startDate: "2026-02-27",
      endDate: "2026-03-01",
      type: "CSI3*",
      result: "3rd - Grand Prix 1.55m (Cash du Pratel)",
      results: [{ placing: "3rd", competition: "Grand Prix 1.55m", horseId: 2 }]
    },
    {
      id: 15,
      name: "CSI3* San Giovanni in Marignano - Spring Tour",
      location: "San Giovanni in Marignano, Italy",
      startDate: "2026-02-13",
      endDate: "2026-02-15",
      type: "CSI3*",
      result: "1st - Grand Prix 1.50m (Cash du Pratel)",
      results: [
        { placing: "1st", competition: "Grand Prix 1.50m (0/0, 38.75s)", horseId: 2 },
        { placing: "1st", competition: "H140 Jump Off (0/0, 37.12s)", horseId: 7 },
        { placing: "3rd", competition: "H145 Ranking Against the Clock (0)", horseId: 1 },
        { placing: "5th", competition: "H145 Ranking Two Phases (0/0)", horseId: 1 }
      ],
      newsId: 6
    },
    {
      id: 18,
      name: "CSI2* Scuderia La Caccia",
      location: "Bedizzole, Italy",
      startDate: "2026-06-12",
      endDate: "2026-06-14",
      type: "CSI2*",
      result: "5th - CSIYH 7YO H135 (Casall du Forezan Z)",
      results: [{ placing: "5th", competition: "CSIYH 7 Y.O. H135 Against the Clock (0)", horseId: 9 }]
    },
    {
      id: 19,
      name: "A5* Le Siepi Cervia",
      location: "Cervia, Italy",
      startDate: "2026-05-22",
      endDate: "2026-05-24",
      type: "A5*",
      result: "4th - C140 a tempo (Lanimotren) · 6th - C140 fasi consecutive (Get In Touch)",
      results: [
        { placing: "4th", competition: "C140 a tempo (0)", horseId: 7 },
        { placing: "7th", competition: "Gran Premio C145", horseId: 7 },
        { placing: "6th", competition: "C140 fasi consecutive (0/0)", horseId: 6 },
        { placing: "7th", competition: "C135 a tempo (0)", horseId: 9 },
        { placing: "9th", competition: "C135 fasi consecutive (0/0)", horseId: 10 }
      ]
    },
    {
      id: 20,
      name: "CSI4* Montefalco - Al Shira'aa Tour",
      location: "Montefalco, Italy",
      startDate: "2026-04-23",
      endDate: "2026-04-26",
      type: "CSI4*",
      result: "13th - Ranking H150 (Milles) · 14th - H140 (Get In Touch)",
      results: [
        { placing: "13th", competition: "Ranking H150 Jump Off Big Tour", horseId: 5 },
        { placing: "14th", competition: "H140 Against the Clock (0)", horseId: 6 }
      ]
    },
    {
      id: 21,
      name: "CSI4* Gorla Minore",
      location: "Gorla Minore, Italy",
      startDate: "2026-03-19",
      endDate: "2026-03-22",
      type: "CSI4*",
      result: "19th - H140 Small Tour (Comme Le Roi) · 21st - H150 Big Tour (Cash du Pratel)",
      results: [
        { placing: "19th", competition: "H140 Against the Clock Small Tour (0)", horseId: 3 },
        { placing: "21st", competition: "H150 Against the Clock Big Tour", horseId: 2 }
      ]
    },
    {
      id: 22,
      name: "CSI4* Scuderia La Caccia",
      location: "Bedizzole, Italy",
      startDate: "2026-03-12",
      endDate: "2026-03-15",
      type: "CSI4*",
      result: "9th - Grand Prix 1.55m (Cape Cod) · 8th - H140 Accumulator (Milles)",
      results: [
        { placing: "9th", competition: "Grand Prix H155 FEI LR Jump Off", horseId: 1 },
        { placing: "10th", competition: "H150 FEI LR Two Rounds (0/4)", horseId: 1 },
        { placing: "8th", competition: "H140 Accumulator with Joker (0)", horseId: 5 },
        { placing: "10th", competition: "H145 Two Phases (0/0)", horseId: 6 }
      ]
    },
    {
      id: 23,
      name: "CSI2* Scuderia La Caccia",
      location: "Bedizzole, Italy",
      startDate: "2026-03-06",
      endDate: "2026-03-08",
      type: "CSI2*",
      result: "13th - H145 Ranking (Lanimotren)",
      results: [{ placing: "13th", competition: "H145 Against the Clock FEI LR (0)", horseId: 7 }]
    },
    {
      id: 24,
      name: "CSI2* Riviera Resort Cattolica",
      location: "Cattolica, Italy",
      startDate: "2026-02-06",
      endDate: "2026-02-08",
      type: "CSI2*",
      result: "3rd - H140 Two Phases (Milles) · 9th - H145 Ranking (Milles)",
      results: [
        { placing: "3rd", competition: "H140 Two Phases (0/0, 25.26s)", horseId: 5 },
        { placing: "9th", competition: "H145 Ranking Against the Clock (0)", horseId: 5 }
      ]
    },
    {
      id: 25,
      name: "Naz. A5* Manerbio - C.E. Al.Cle.",
      location: "Manerbio, Italy",
      startDate: "2026-01-30",
      endDate: "2026-02-01",
      type: "A5*",
      result: "3rd - C140 fasi consecutive (Get In Touch) · 4th - C140 (Aga Blue DMH Z) · 5th - Gran Premio C145 (Get In Touch)",
      results: [
        { placing: "3rd", competition: "C140 fasi consecutive (0/0)", horseId: 6 },
        { placing: "5th", competition: "Gran Premio C145 Outdoor", horseId: 6 },
        { placing: "4th", competition: "C140 a tempo (0)", horseId: 4 },
        { placing: "5th", competition: "C135 a tempo (0)", horseId: 4 },
        { placing: "8th", competition: "Gran Premio C145 Outdoor", horseId: 7 }
      ]
    },
    {
      id: 16,
      name: "CSIO4* Sopot",
      location: "Sopot, Poland",
      startDate: "2025-06-12",
      endDate: "2025-06-15",
      type: "CSIO4*",
      result: "1st - €105,500 Lotto Cup Grand Prix 1.60m (Cape Cod)",
      results: [{ placing: "1st", competition: "€105,500 Lotto Cup Grand Prix 1.60m", horseId: 1 }],
      newsId: 1
    },
    {
      id: 17,
      name: "CSIO5* Piazza di Siena",
      location: "Rome, Italy",
      startDate: "2025-05-22",
      endDate: "2025-05-25",
      type: "CSIO5*",
      result: "2nd - Speed Class (Cape Cod)",
      results: [{ placing: "2nd", competition: "Speed Class 1.50m (36.79s)", horseId: 1 }],
      newsId: 3
    }
  ]
};

export const blog = [
  {
    id: 1,
    title: "The Road to Grand Prix Success",
    author: "Giacomo Bassi",
    date: "July 2, 2025",
    category: "Training",
    excerpt: "Winning at the highest level requires dedication, preparation, and an exceptional partnership with your horse. Here's what goes into preparing for a Grand Prix...",
    image: "https://customer-assets.emergentagent.com/job_11a5c023-0086-4456-b2f2-508c2ca946e7/artifacts/rbc29mlo_27055dd5-5172-4c5d-8485-fe7161e68e29.jpeg",
    content: `Winning the CSIO Sopot Grand Prix was a dream come true, but it was the result of months of careful preparation and training. Cape Cod and I have developed a partnership built on trust and understanding.

Every Grand Prix requires meticulous planning - from studying the course to understanding your horse's strengths. The jump-off demands both speed and precision, and that's where experience makes the difference.

Key factors for success include maintaining your horse's fitness, building confidence through consistent training, and staying mentally focused under pressure. The relationship between horse and rider is everything in our sport.`
  },
  {
    id: 2,
    title: "Representing Italy on the International Stage",
    author: "Giacomo Bassi",
    date: "June 15, 2025",
    category: "Competition",
    excerpt: "Being selected for the Italian team at the Longines EEF Series Final is an incredible honor. Nations Cup events bring out the best in every rider...",
    image: "https://customer-assets.emergentagent.com/job_11a5c023-0086-4456-b2f2-508c2ca946e7/artifacts/5rbe7vbt_16a68f21-a164-4a01-8488-d0a4ba0b5e7c.jpeg",
    content: `Competing for your country adds a special dimension to showjumping. The team atmosphere, the shared goals, and the pride of representing Italy drive me to perform at my absolute best.

Nations Cup competitions test not just individual skill but team strategy and cohesion. Every clear round contributes to the team's success, and that collective responsibility is both challenging and rewarding.

I'm proud to be part of Italy's strong equestrian tradition and grateful for the opportunity to compete alongside some of the best riders in the world.`
  },
  {
    id: 3,
    title: "Meet Cape Cod: My Champion Partner",
    author: "Giacomo Bassi",
    date: "May 20, 2025",
    category: "Horses",
    excerpt: "Every successful rider has that special horse who changes everything. For me, that horse is Cape Cod. Let me tell you about our journey together...",
    image: "https://customer-assets.emergentagent.com/job_11a5c023-0086-4456-b2f2-508c2ca946e7/artifacts/58fltf0b_989aa3a0-f2bd-46a1-8284-dc004549e4ec.jpeg",
    content: `Cape Cod came into my life in 2023, and from the first ride, I knew we had something special. His intelligence, carefulness, and competitive spirit make him exceptional.

What makes Cape Cod unique is his ability to stay focused under pressure. In the Sopot Grand Prix, he was incredible - fast, careful, and completely in tune with me throughout the course.

Building a partnership with a horse takes time, patience, and mutual respect. Every horse is different, and understanding what motivates them is key to unlocking their potential. With Cape Cod, we've found that perfect balance.`
  },
  {
    id: 4,
    title: "Winter Training Philosophy",
    author: "Giacomo Bassi",
    date: "February 8, 2025",
    category: "Training",
    excerpt: "The winter months are crucial for building the foundation of success. Here's how we approach off-season training to come back stronger...",
    image: "https://customer-assets.emergentagent.com/job_11a5c023-0086-4456-b2f2-508c2ca946e7/artifacts/3xfifpq0_IMG_5643.jpeg",
    content: `Winter training is about more than maintaining fitness - it's when we develop new skills, strengthen weaknesses, and build deeper partnerships with our horses.

Our program focuses on variety: flatwork, gymnastic exercises, and mental conditioning. The horses need to stay engaged and happy, so we mix intensive training with lighter sessions and plenty of turnout time.

For the young horses, winter is particularly important. It's when we establish good habits and build their confidence progressively. Each horse develops at their own pace, and respecting that is crucial for long-term success.`
  },
  {
    id: 5,
    title: "The Art of Course Walking",
    author: "Giacomo Bassi",
    date: "January 15, 2025",
    category: "Training",
    excerpt: "Course walking is one of the most underrated skills in showjumping. Here's how I approach every course to maximize our chances of success...",
    image: "https://customer-assets.emergentagent.com/job_11a5c023-0086-4456-b2f2-508c2ca946e7/artifacts/wrmhcw3o_d59b9750-8b52-46c2-9fb7-fd0f967809a4.jpeg",
    content: `Before every competition, I walk the course multiple times. Each walk has a different purpose - the first to understand the flow, the second to count strides, and the third to visualize my ride.

Understanding distances between fences is crucial. A half-stride difference can mean the difference between a clear round and a rail down. I always consider my horse's natural stride length and adjust my plan accordingly.

The best riders aren't just reactive - they're proactive. By walking the course thoroughly, we can anticipate challenges and prepare solutions before we ever enter the ring.`
  }
];